var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content__wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('welcome',{attrs:{"title":_vm.candidateTitle,"firstName":_vm.candidate.first_name,"lastName":_vm.candidate.last_name},on:{"next":_vm.next}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }